import * as io from 'io-ts';

const Disclosure = io.intersection([
  io.type({
    type: io.string,
  }),
  io.partial({
    acceptedAt: io.string,
    checksum: io.string,
  }),
]);

export type Disclosure = io.TypeOf<typeof Disclosure>;

export const DisclosuresAttribute = io.union([io.array(Disclosure), io.null]);
export type DisclosuresAttribute = io.TypeOf<typeof DisclosuresAttribute>;

export const HasDisclosures = io.type({
  disclosures: DisclosuresAttribute,
});

export type HasDisclosures = io.TypeOf<typeof HasDisclosures>;

export enum DisclosureOperation {
  CHECKOUT = 'CHECKOUT',
  AUTOPAY_ENROLLMENT = 'AUTOPAY_ENROLLMENT',
  ONE_TIME_PAYMENT = 'ONE_TIME_PAYMENT',
  HARDSHIP = 'HARDSHIP',
}

export const GenerateDisclosureRequest = io.intersection([
  io.type({
    disclosureOperation: io.union([
      io.literal(DisclosureOperation.CHECKOUT),
      io.literal(DisclosureOperation.AUTOPAY_ENROLLMENT),
      io.literal(DisclosureOperation.ONE_TIME_PAYMENT),
      io.literal(DisclosureOperation.HARDSHIP),
    ]),
  }),
  io.partial({
    paymentMethodID: io.string,
  }),
]);

export type GenerateDisclosureRequest = io.TypeOf<
  typeof GenerateDisclosureRequest
>;

export const DisclosureResponse = io.type({
  disclosureID: io.string,
  disclosureName: io.string,
  documentURL: io.string,
});
export type DisclosureResponse = io.TypeOf<typeof DisclosureResponse>;

export const GenerateDisclosureResponse = io.type({
  disclosureRef: io.string, // checksum -> PaymentAgreementDocument
  disclosures: io.array(DisclosureResponse),
});

export type GenerateDisclosureResponse = io.TypeOf<
  typeof GenerateDisclosureResponse
>;

// Just a type alias for GenerateDisclosureResponse
export type GeneratedDisclosures = io.TypeOf<typeof GenerateDisclosureResponse>;
